import { useNavigate } from 'react-router-dom'
import PullToRefresh from './PullToRefresh'
import { useHaptics } from '../../utils/haptics'
import { useNotifications } from '../../contexts/NotificationContext'

// Icons
function ArrowLeftIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M19 12H5M12 19l-7-7 7-7"/>
    </svg>
  )
}

export default function PageLayout({ 
  title, 
  subtitle, 
  children, 
  headerAction,
  className = "",
  onRefresh,
  showBackButton = false,
  onBack
}) {
  const navigate = useNavigate()
  const haptics = useHaptics()
  const { showSuccess, showError } = useNotifications()

  const handleRefresh = async () => {
    haptics.light()
    try {
      // Simulate refresh delay
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      // Call custom refresh function if provided
      if (onRefresh) {
        await onRefresh()
      }
      
      haptics.success()
      showSuccess(`${title} refreshed!`)
    } catch (error) {
      console.error('Refresh error:', error)
      haptics.error()
      showError('Failed to refresh data')
    }
  }

  return (
    <div className="min-h-screen bg-white relative">
      {/* Consistent Header */}
      <div className="sticky top-0 z-20 bg-white px-6 pt-6 pb-4 shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {showBackButton && (
              <button 
                onClick={() => {
                  haptics.light()
                  if (onBack) {
                    onBack()
                  } else {
                    navigate(-1)
                  }
                }}
                className="p-2 hover:bg-slate-100 rounded-xl touch-manipulation"
              >
                <ArrowLeftIcon />
              </button>
            )}
            <div>
              <h1 className="text-xl font-bold text-slate-900">{title}</h1>
              {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
            </div>
          </div>
          {headerAction && <div>{headerAction}</div>}
        </div>
      </div>

      {/* Consistent Content Area with Pull to Refresh */}
      <PullToRefresh onRefresh={handleRefresh}>
        <div className={`px-6 py-6 space-y-6 pb-24 ${className}`}>
          {children}
        </div>
      </PullToRefresh>
    </div>
  )
}
